"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeSelectionPopupCms = void 0;
var TimeSelectionPopupCms = /** @class */ (function () {
    function TimeSelectionPopupCms() {
        this.titleLabel = 'Schedule your delivery';
        this.noTimeSlotAvailableErrTxt = 'There are no available timeslots for this day.';
        this.subHeaderDOOLabel = 'When would you like to have your device delivered?';
        this.subHeaderPDOLabel = 'You\'ll have up to an hour with an expert to ask ' +
            'questions and get help setting up your device. When would you like to have it delivered? ';
        this.buttonTextLabel = 'Update my date & time';
        this.apiFailureMsgLabel = 'Uh-oh! We can\'t check for available dates and times right now.Please try again later.';
        this.currentAppointment = ' (current appointment)';
    }
    return TimeSelectionPopupCms;
}());
exports.TimeSelectionPopupCms = TimeSelectionPopupCms;
//# sourceMappingURL=TimeSelectionPopup.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoWLS/SameDay/TimeSelectionPopup.cms.js
// module id = 1997
// module chunks = 8